import { FormHelperText, Grid } from "@mui/material";
import FormNumber from "../../Components/FormNumber";
import FormText from "../../Components/FormText";
import { Form } from "../../system/useForm";
import Tile from "../../Components/Tiles/Tile";

interface Props {
	form: Form;
	modelNameRequired?: boolean;
	modelVersion?: string;
}

const LeasmanMissingFieldsTile = ({ form, modelNameRequired, modelVersion }: Props) => {
	return (
		<Tile title="Fehlende Schwacke-Daten">
			<Grid container spacing={3}>
				{modelNameRequired && (
					<>
						<FormText
							form={form}
							name="leasman.typeOverrides.model.name"
							label="Modellname"
							options={{ required: true }}
							fullWidth
						/>
						{modelVersion && (
							<Grid item xs={12} sx={{ mt: -2 }}>
								<FormHelperText>
									Modellversion: {modelVersion}
								</FormHelperText>
							</Grid>
						)}
					</>
				)}
				<FormNumber
					form={form}
					name="leasman.typeOverrides.body.tires"
					label="Reifenanzahl"
					fullWidth
				/>
				<FormNumber
					form={form}
					name="leasman.typeOverrides.body.wheelBase"
					label="Radstand (mm)"
					fullWidth
				/>
				<FormNumber
					form={form}
					name="leasman.typeOverrides.body.size.length"
					label="Länge (mm)"
					fullWidth
				/>
				<FormNumber
					form={form}
					name="leasman.typeOverrides.body.size.height"
					label="Höhe (mm)"
					fullWidth
				/>
				<FormNumber
					form={form}
					name="leasman.typeOverrides.body.size.width"
					label="Breite (mm)"
					fullWidth
				/>
				<FormNumber
					form={form}
					name="leasman.typeOverrides.body.weight.base"
					label="Leergewicht (kg)"
					fullWidth
				/>
				<FormNumber
					form={form}
					name="leasman.typeOverrides.body.weight.payload"
					label="Nutzlast (kg)"
					fullWidth
				/>
				<FormNumber
					form={form}
					name="leasman.typeOverrides.body.weight.total"
					label="Gesamtgewicht (kg)"
					fullWidth
				/>
				<FormNumber
					form={form}
					name="leasman.typeOverrides.body.trunkVolume.min"
					label="Kofferraumvolumen min. (l)"
					fullWidth
				/>
				<FormNumber
					form={form}
					name="leasman.typeOverrides.body.trunkVolume.max"
					label="Kofferraumvolumen max. (l)"
					fullWidth
				/>
				<FormNumber
					form={form}
					name="leasman.typeOverrides.engine.fuelCapacity"
					label="Tankvolumen (l)"
					fullWidth
				/>
			</Grid>
		</Tile>
	);
};

export default LeasmanMissingFieldsTile;
